import './App.css';
import CarouselSlider from './components/CarouselSlider';
import HomePage from './components/HomePage';
import NavBarMain from './components/NavBarMain';
import RouterMain from './components/RouterMain';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
   <div className="min-h-screen flex flex-col">
    <NavBarMain/>
    <main className="flex-1">
      <RouterMain/>
    </main>
    <Footer/>
    <WhatsAppButton/>
       </div>
  );
}

export default App;
